import {inject, Injectable} from '@angular/core';
import {ListDataStore} from '../../stores/list-data.store';
import {PaginatedListData} from '../../models/paginated-list-data.model';
import {HashMap} from '../../modules/akita-mimic/models/hash-map.model';

@Injectable({
    providedIn: 'root'
})
export class ListDataService {
    private readonly listDataStore = inject(ListDataStore);

    public addListData(data: PaginatedListData): void {
        this.listDataStore.upsert(data.id, data);
    }

    public updateListData<T>(name: string, dataArray: Array<number | T>, marked: Array<string>, deleted: Array<string>, showRefreshListToast: boolean): void {
        this.listDataStore.update(name, {
            data: JSON.parse(JSON.stringify(dataArray)),
            updated: new Date(),
            marked,
            deleted,
            showRefreshListToast,
        });
    }

    public removeListData(name: string): void {
        this.listDataStore.remove(name);
    }

    public resetListActiveState(): void {
        const paginatedLists: HashMap<PaginatedListData> | undefined = this.listDataStore.getValue().entities;
        if (paginatedLists) {
            for (const paginatedListData of Object.values(paginatedLists)) {
                if (paginatedListData.activated) {
                    this.listDataStore.update(paginatedListData.id, { activated: undefined });
                }
            }
        }
        this.listDataStore.setActive([]);
    }

    public setListActive(listName: string, activated: Date | undefined): void {
        this.listDataStore.update(listName, { activated });
        this.listDataStore.addActives([listName]);
    }

    public resetListStorage(): void {
        this.listDataStore.reset();
    }
}
